import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var BlockerContentInlineStyles = /*#__PURE__*/function () {
  function BlockerContentInlineStyles() {
    _classCallCheck(this, BlockerContentInlineStyles);
  }

  _createClass(BlockerContentInlineStyles, null, [{
    key: "inner",
    value: function inner(_ref) {
      var _ref$layout = _ref.layout,
          type = _ref$layout.type,
          dialogBorderRadius = _ref$layout.dialogBorderRadius,
          _ref$design = _ref.design,
          borderWidth = _ref$design.borderWidth,
          borderColor = _ref$design.borderColor,
          textAlign = _ref$design.textAlign,
          fontColor = _ref$design.fontColor,
          fontInheritFamily = _ref$design.fontInheritFamily,
          fontFamily = _ref$design.fontFamily,
          antiAdBlocker = _ref.customCss.antiAdBlocker;
      var style = {
        textAlign: textAlign,
        fontFamily: fontInheritFamily ? undefined : fontFamily,
        color: fontColor,
        // margin: "10px 0",
        borderRadius: type === "dialog" ? +dialogBorderRadius : undefined,
        border: type === "banner" ? borderWidth > 0 ? "".concat(borderWidth, "px solid ").concat(borderColor) : undefined : undefined
      };
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-inner",
        style: style
      };
    }
  }, {
    key: "content",
    value: function content(_ref2) {
      var antiAdBlocker = _ref2.customCss.antiAdBlocker;
      return {
        className: antiAdBlocker === "y" ? undefined : "rcb-content",
        style: {}
      };
    }
  }]);

  return BlockerContentInlineStyles;
}();

export { BlockerContentInlineStyles };